import { useEffect, useState } from "react";

export const LoadingDots = () => {
  const [dots, setDots] = useState(".");
  useEffect(() => {
    const id = setInterval(() => {
      setDots((dots) => (dots.length === 3 ? "." : dots + "."));
    }, 500);

    return () => {
      clearInterval(id);
    };
  }, []);
  return <span data-testid={"loading-dots"}>{dots}</span>;
};
